/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { NgModule } from '@angular/core';
import { DataPersistence } from './data-persistence';
/**
 * \@whatItDoes Provides services for enterprise Angular applications.
 *
 * See {\@link DataPersistence} for more information.
 */
export class NxModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return { ngModule: NxModule, providers: [DataPersistence] };
    }
}
NxModule.decorators = [
    { type: NgModule, args: [{},] },
];

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibngubW9kdWxlLmpzIiwic291cmNlUm9vdCI6Im5nOi8vQG5yd2wvbngvIiwic291cmNlcyI6WyJzcmMvbngubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLEVBQXVCLFFBQVEsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUM5RCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sb0JBQW9CLENBQUM7Ozs7OztBQVFyRCxNQUFNOzs7O0lBQ0osTUFBTSxDQUFDLE9BQU87UUFDWixNQUFNLENBQUMsRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxDQUFDLGVBQWUsQ0FBQyxFQUFFLENBQUM7S0FDN0Q7OztZQUpGLFFBQVEsU0FBQyxFQUFFIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTW9kdWxlV2l0aFByb3ZpZGVycywgTmdNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9jb3JlJztcbmltcG9ydCB7IERhdGFQZXJzaXN0ZW5jZSB9IGZyb20gJy4vZGF0YS1wZXJzaXN0ZW5jZSc7XG5cbi8qKlxuICogQHdoYXRJdERvZXMgUHJvdmlkZXMgc2VydmljZXMgZm9yIGVudGVycHJpc2UgQW5ndWxhciBhcHBsaWNhdGlvbnMuXG4gKlxuICogU2VlIHtAbGluayBEYXRhUGVyc2lzdGVuY2V9IGZvciBtb3JlIGluZm9ybWF0aW9uLlxuICovXG5ATmdNb2R1bGUoe30pXG5leHBvcnQgY2xhc3MgTnhNb2R1bGUge1xuICBzdGF0aWMgZm9yUm9vdCgpOiBNb2R1bGVXaXRoUHJvdmlkZXJzIHtcbiAgICByZXR1cm4geyBuZ01vZHVsZTogTnhNb2R1bGUsIHByb3ZpZGVyczogW0RhdGFQZXJzaXN0ZW5jZV0gfTtcbiAgfVxufVxuIl19